import { render, staticRenderFns } from "./PapertonRoute.vue?vue&type=template&id=b22aa0c4&"
import script from "./PapertonRoute.vue?vue&type=script&lang=js&"
export * from "./PapertonRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports